import { ApolloProvider } from "@apollo/client";
import React from "react";

import { externalApolloClient } from "settings/apolloExternal";

export const ExternalApolloProvider = ({ children }: { children: React.ReactNode }): JSX.Element => (
  <ApolloProvider client={externalApolloClient}>{children}</ApolloProvider>
);
